import axios from 'axios';
import { ERROR_APP_UPGRADE } from '../defines';

import packageJson from '../../package.json';
import { toJS } from 'mobx';
import {
  LocalStorageKeyEnum,
  removeLocalStorageItem,
} from './local-storage-handler';

const LOGIN_URL = '/login/dev';

const errorHandler = (err: any) => {
  const { response } = err;
  if (!response) {
    return;
  }
  const { status } = response;
  const { pathname } = window.location;
  const { code } = response.data;

  if (status === 503) {
    throw response;
  } else if (status === 401) {
    const respData = response.data;
    console.log('401 Error, response.data: ', respData);
    if (respData.shouldRedirect) {
      window.location.replace(respData.redirectPath);
    } else if (pathname === LOGIN_URL) {
      throw response;
    } else {
      console.log('Not Found Login Session');
      removeLocalStorageItem(LocalStorageKeyEnum.TOKEN);
      window.location.href = response.data.redirect;
    }
  } else if (status === 400) {
    if (code === ERROR_APP_UPGRADE.code) {
      console.log('Client Upgrade');
      window.location.reload();
    }
  }
  console.log(response);
  throw response;
};

export const get = async (
  url: string,
  params?: any,
  name: string = 'get',
): Promise<any> => {
  try {
    const res = await axios.get(url, {
      params,
      headers: {
        Version: packageJson.version,
      },
    });
    console.log('[axios get]', name, { res });
    return res.data;
  } catch (err) {
    console.log('[axios get]', name, { err });
    errorHandler(err);
  }
};

export const post = async (
  url: string,
  obj: Record<string, any>,
  name: string = 'post',
): Promise<any> => {
  try {
    const res = await axios.post(url, JSON.stringify(toJS(obj)), {
      headers: {
        Version: packageJson.version,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });
    console.log('[axios post]', name, { res });
    return res.data;
  } catch (err) {
    errorHandler(err);
  }
};

export const getFile = async (
  url: string,
  params?: any,
  name: string = 'getFile',
): Promise<string | undefined> => {
  try {
    const res = await axios.get(url, {
      params,
      headers: {
        Version: packageJson.version,
      },
      responseType: 'arraybuffer',
    });
    console.log({ headers: res.headers['content-type'] });

    const base64String = btoa(
      new Uint8Array(res.data).reduce(
        (data, byte) => data + String.fromCharCode(byte),
        '',
      ),
    );
    const data = `data:image/jpeg;base64,${base64String}`;

    console.log('[axios get]', name, { res });
    return data;
  } catch (err) {
    console.error(err);
    errorHandler(err);
  }
};

export const downloadFile = async (
  url: string,
  params?: any,
  name: string = 'downloadFile',
  fileName: string = '',
): Promise<void> => {
  try {
    const res = await axios.get(url, {
      params,
      headers: {
        Version: packageJson.version,
      },
      responseType: 'blob',
    });
    const downloadUrl = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    console.log('[axios get]', name, { res });
  } catch (err) {
    console.error(err);
    errorHandler(err);
  }
};

export const postFile = async (
  url: string,
  file: File,
  name: string = 'postFile',
): Promise<any> => {
  const formData = new FormData();
  formData.append('file', file);
  try {
    const res = await axios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    console.log('[axios postFile]', name, { res });
    return res.data;
  } catch (err) {
    errorHandler(err);
  }
};

export const put = async (
  url: string,
  obj: Record<string, any>,
  name: string = 'put',
): Promise<any> => {
  try {
    const res = await axios.put(url, JSON.stringify(toJS(obj)), {
      headers: {
        Version: packageJson.version,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });
    console.log('[axios put]', name, { res });
    return res.data;
  } catch (err) {
    errorHandler(err);
  }
};

export const patch = async (
  url: string,
  obj: Record<string, any>,
  name: string = 'patch',
): Promise<any> => {
  try {
    const res = await axios.patch(url, JSON.stringify(toJS(obj)), {
      headers: {
        Version: packageJson.version,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });
    console.log('[axios patch]', name, { res });
    return res.data;
  } catch (err) {
    errorHandler(err);
  }
};
